<app-container
    [user]="user$ | async"
    [isEmbedded]="isEmbedded"
    [isMobile]="isMobile$ | async"
    [isFirstSignup]="isFirstSignup$ | async"
></app-container>
